import { CommonModule } from '@angular/common'
import { Component, ChangeDetectionStrategy } from '@angular/core'
import { RouterLink } from '@angular/router'

@Component({
  selector: 'app-auth-logo',
  standalone: true,
  imports: [RouterLink, CommonModule],
  changeDetection: ChangeDetectionStrategy.Eager,
  template: ` <a routerLink="/" class="auth-brand mb-4">
    <img
      src="assets/images/logo-dark.png"
      alt="dark logo"
      height="24"
      class="logo-dark"
    />
    <img
      src="assets/images/logo.png"
      alt="logo light"
      height="24"
      class="logo-light"
    />
  </a>`,
})
export class AuthLogoComponent {}
